<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-select v-model="lb_value" placeholder="请选择" size="small" filterable clearable>
                            <el-option v-for="item in  lb_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" >
                <el-table-column prop="id" label="id"></el-table-column>
                <el-table-column prop="questionnaire_name" label="问卷标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="问卷封面">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; " v-if="scope.row.file_info" :src="scope.row.file_info[0].url"
                            :preview-src-list="[scope.row.file_info[0].url]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="所有问题" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link type="primary" @click="opendetail(scope.row,scope.$index)">查看</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="已填用户" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link type="primary" @click="openuserlist(scope.row,scope.$index)">查看</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="问卷设置" :visible.sync="dialogVisible" center top="100px" width="40%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content ">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="问卷标题" prop='lb_title'>
                        <el-input v-model="ruleForm.lb_title" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="问卷封面" required>
                        <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                            :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'1' }"
                            :file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="问卷详情">
                        <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="ruleForm.lb_content">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!--  -->
        <!-- 问题-->
        <el-dialog title="此问卷内问题" :visible.sync="contentvotedetail" top="50px" width="60%" class="dialogs">
            <el-divider></el-divider>
            <Contentvotelist ref="votelist" />
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="contentvotedetail=false" size="small">确定</el-button>
            </span>
        </el-dialog>
        <!-- 投票人员列表-->
        <el-dialog title="已填写用户" :visible.sync="uservotelist" top="70px" width="50%" class="dialogs">
            <el-divider></el-divider>
            <Surveyser ref="userlist" />
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uservotelist=false" size="small">确定</el-button>
            </span>
        </el-dialog>


    </div>
</template>
<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    import Contentvotelist from './problems.vue';
    import Surveyser from './surveyuser.vue';
    import comment from '@/components/header/comment.vue';
    import Uservoterecord from '../../../components/contentvotelist/uservotelist';
    export default {
        components: {
            tinymce,
            Contentvotelist,
            Surveyser,
            Uservoterecord,
            comment
        },
        data() {
            return {

             
                lb_value: '',
                lb_options: [],
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,
                // 
                activityId: '',
                dialogVisible: false,
                contentvotedetail: false,
                uservotelist: false,
                subloading: false,

                ruleForm: {
                    lb_title: '',
                    lb_content: '',
                    lb_mapList: [],
                },
                mapListed: [],
                rule: {
                    lb_title: [{
                        required: true,
                        message: '请填写标题',
                        trigger: 'blur'
                    }],
                },
                // 
                urls: '',
                // 
                dialogs: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios.post("/admin/pc/questionnaire/list", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        // health_category_id: that.lb_value,

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.data
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },

            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.activityId = ''
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm.lb_title = ''
                that.ruleForm.lb_content = ''
                that.ruleForm.lb_mapList = []
                that.mapListed = []

            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (that.mapListed.length < 1) return that.$message.error('请上传封面');
                        that.subloading = true
                        let urls;
                        if (this.activityId && this.activityId != '') {
                            urls = "/admin/pc/questionnaire/update"
                        } else {
                            urls = "/admin/pc/questionnaire/create"
                        }
                        axios.post(urls, {
                                id: that.activityId,
                                questionnaire_name: that.ruleForm.lb_title,
                                detail: that.ruleForm.lb_content,
                                file_info: that.mapListed,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = true
                            })
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },

            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.ruleForm.lb_mapList = row.file_info
                that.mapListed = row.file_info
                that.ruleForm.lb_content = row.detail
                that.ruleForm.lb_title = row.questionnaire_name
                that.dialogVisible = true
                that.activityId = row.id

            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该问卷, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/questionnaire/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            opendetail(row, index) {
                this.contentvotedetail = true
                this.$nextTick(() => {
                    this.$refs.votelist.textId = row.id
                    this.$refs.votelist.getlist(row.id)
                    // this.$refs.votelist.votelist=row.content
                })
            },
            gettimes() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                let hour = nowDate.getHours(); //获取系统时，
                let min = nowDate.getMinutes(); //分
                let sec = nowDate.getSeconds(); //秒
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                hour = hour > 9 ? hour : '0' + hour
                min = min > 9 ? min : '0' + min
                sec = sec > 9 ? sec : '0' + sec
                return `${year}-${month}-${day} ${hour}:${min}`;
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            openuserlist(row,index){
                this.uservotelist=true
                 this.$nextTick(() => {
                    this.$refs.userlist.eid = row.id
                    this.$refs.userlist.getuserlist(row.id)
                })
            },

        },

    };
</script>


<style lang='scss' scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .votebox {
        max-height: 500px;
        overflow-y: auto;
    }
  
    .forms-lines .el-form-item {
        margin-bottom: 22px !important;
    }
</style>